import React from "react";
import {ToggleWrapper} from "./ToggleWrapper";
import {ToggledFeature} from "./featureToggleService";

export function AppleSignInToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.APPLE_SIGNIN}>
      {props.children}
    </ToggleWrapper>
  );
}
